// ScreenShareCanvasHook — for the standalone /screen-share/:sn page
// Uses a <canvas> element. Resizes only when dimensions change to avoid clearing the buffer.
const ScreenShareCanvasHook = {
  mounted() {
    this.canvas = this.el;
    this.ctx = this.canvas.getContext("2d", { alpha: false });
    this.canvas.width = 1280;
    this.canvas.height = 720;
    this.ctx.fillStyle = "#000";
    this.ctx.fillRect(0, 0, 1280, 720);

    this._pending = null;

    // Store as named ref so we can removeEventListener on destroy
    this._onMouseDown = (e) => {
      const rect = this.canvas.getBoundingClientRect();
      // Normalize to 0-1 range so the device can map to its own resolution
      const x = (e.clientX - rect.left) / rect.width;
      const y = (e.clientY - rect.top) / rect.height;
      this.pushEvent("touch_event", { x, y });
      // Ripple position: offset of click relative to canvas's own top-left within the wrapper
      const wrapperRect = this.canvas.parentElement.getBoundingClientRect();
      this._flashTap(e.clientX - wrapperRect.left, e.clientY - wrapperRect.top);
    };
    this.canvas.addEventListener("mousedown", this._onMouseDown);

    this.handleEvent("screen_frame", ({ data }) => {
      if (this._pending) {
        this._pending.onload = null;
        this._pending.onerror = null;
      }

      const img = new Image();
      this._pending = img;

      img.onload = () => {
        this._pending = null;
        if (this.canvas.width !== img.naturalWidth || this.canvas.height !== img.naturalHeight) {
          this.canvas.width = img.naturalWidth;
          this.canvas.height = img.naturalHeight;
        }
        this.ctx.drawImage(img, 0, 0);
      };

      img.onerror = (e) => {
        this._pending = null;
        console.error("[ScreenShareCanvas] frame decode failed", e);
      };

      img.src = `data:image/jpeg;base64,${data}`;
    });
  },

  destroyed() {
    if (this._pending) {
      this._pending.onload = null;
      this._pending.onerror = null;
      this._pending = null;
    }
    if (this._onMouseDown) {
      this.canvas.removeEventListener("mousedown", this._onMouseDown);
      this._onMouseDown = null;
    }
  },

  // Brief visual ripple at the click point so the operator knows the tap registered
  _flashTap(px, py) {
    const circle = document.createElement("div");
    circle.style.cssText = `
      position:absolute; pointer-events:none;
      width:32px; height:32px; border-radius:50%;
      border:2px solid rgba(255,255,255,0.8);
      left:${px - 16}px; top:${py - 16}px;
      animation:tap-ripple 0.4s ease-out forwards;
    `;
    const wrapper = this.canvas.parentElement;
    wrapper.style.position = "relative";
    wrapper.appendChild(circle);
    setTimeout(() => circle.remove(), 420);
  }
};

// Inject keyframe animation once
if (!document.getElementById("tap-ripple-style")) {
  const style = document.createElement("style");
  style.id = "tap-ripple-style";
  style.textContent = `
    @keyframes tap-ripple {
      from { opacity: 1; transform: scale(0.5); }
      to   { opacity: 0; transform: scale(2); }
    }
  `;
  document.head.appendChild(style);
}
export default ScreenShareCanvasHook;
